/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import PropTypes from 'prop-types';

import './TextItem.scss';

interface TextItemProps {
    defaultContent: React.ReactNode;
    highlighted: boolean;
    highlightedContent?: React.ReactNode;
}

const TextItem: FunctionComponent<TextItemProps> = ({
    highlighted,
    highlightedContent,
    defaultContent,
}) => {
    return (
        <React.Fragment>
            <span>{highlighted ? highlightedContent || defaultContent : defaultContent}</span>
            {highlighted ? <div className="highlighted"></div> : null}
        </React.Fragment>
    );
};

TextItem.propTypes = {
    defaultContent: PropTypes.node.isRequired,
    highlighted: PropTypes.bool.isRequired,
    highlightedContent: PropTypes.node,
};

export default TextItem;
